// var fs = Meteor.npmRequire('fs');
//
// eval(fs.readFileSync('bands.csv')+'');

